export default {
	project_name: 'Uniglobo',
	home_drills_title: 'DRILLS',
	home_events_title: 'MEUS EVENTOS',
	home_keep_watching_title: 'CONTINUE ASSISTINDO',
	home_library_title: 'BIBLIOTECA',
	home_live_classes_title: 'AULAS AO VIVO',
	home_news_title: 'NOTÍCIAS',
	home_online_courses_title: 'CURSOS ONLINE',
	home_podcasts_title: 'PODCASTS',
	home_surveys_title: 'PESQUISAS',
	home_tags_title: 'EM FOCO',
	home_trails_title: 'TRILHAS',
	home_webinars_title: 'WEBINARS',
	navbar_about_title: 'A Uniglobo',
}
